import script from "./modes-set.vue?vue&type=script&setup=true&lang=js"
export * from "./modes-set.vue?vue&type=script&setup=true&lang=js"

import "./modes-set.vue?vue&type=style&index=0&id=7d01b86d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d01b86d"]])

export default __exports__